import { EditableMarkdownFormComponent } from "components/Form/components/EditableMarkdown/EditableMarkdownFormComponent";
import { Form } from "components/Form/components/Form/Form";
import { Field } from "react-final-form";
import "./ResourcesPageHeaderDescriptionForm.scss";

export const ResourcePageHeaderDescriptionForm = ({
    defaultValue,
    isReadOnly,
}: {
    defaultValue?: string;
    isReadOnly?: boolean;
}) => (
    <div className="resource-page-header-form-description" data-testid="resourceFormSubtitle">
        <Form.Row verticalCenter>
            <Field
                name="description"
                id="description"
                allowNull={true}
                parse={(x) => x}
                defaultValue={defaultValue}
            >
                {({ input, meta }) => {
                    return (
                        <EditableMarkdownFormComponent
                            input={input}
                            meta={meta}
                            fieldProps={{
                                className: `text-base ${isReadOnly ? "text-dark-grey" : ""}`,
                                isCollapsible: true,
                                // The description reads and edits inside one
                                // bordered light-grey box and enters edit mode on
                                // click of the box (no pencil, no reflow, no
                                // size/position jump). See
                                // operator-task-fe-record-description-edit-view-redesign.
                                editOnClick: true,
                            }}
                            fieldAttr={{
                                placeholder: "Add a description",
                                disabled: isReadOnly,
                            }}
                        />
                    );
                }}
            </Field>
        </Form.Row>
    </div>
);
